import { HttpClient } from '@angular/common/http';
import { effect, Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OfficeTemplatesService } from './office-templates.service';
import { tap } from 'rxjs';
import { Plan, SSPlan } from 'src/app/models/plan.model';

@Injectable({
  providedIn: 'root'
})
export class OfficeTemplatesPlansService {

  BASEURL = environment.landmark_API_URL + '/standards/ssplans';

  constructor(
    private http: HttpClient,
    private officeTemplatesService: OfficeTemplatesService
  ) {
   }

   addPlans(plan: Plan[]) {
    const ssid = this.officeTemplatesService.selectedTemplate()?.SSID || 0;
    const fid = this.officeTemplatesService.selectedTemplate()?.FID || 0;
    const body = {
      ssid: ssid,
      fid: fid,
      plans: plan.map(p => ({ PlanID: p.PlanID }))
    }
    return this.http.post<SSPlan[]>(this.BASEURL, body).pipe(
      tap(plans => {
        this.officeTemplatesService.updateTemplate({
          SSPlans: [...(this.officeTemplatesService.selectedTemplate()?.SSPlans || []), ...plans]
        });
        for(const p of plans) {
          this.officeTemplatesService.purgePlan(p.PlanID, ssid);
        }
      })
    )
   }

   removePlan(plan: SSPlan) {
    return this.http.delete<SSPlan>(`${this.BASEURL}/${plan.SSPlanID}`).pipe(
      tap(
        plan => {
          this.officeTemplatesService.updateTemplate({
            SSPlans: this.officeTemplatesService.selectedTemplate()?.SSPlans.filter(p => p.SSPlanID !== plan.SSPlanID) || []
          });
        }
      )
    )
    
    // .subscribe(plan => {
    //   this.officeTemplatesService.updateTemplate({
    //     SSPlans: this.officeTemplatesService.selectedTemplate()?.SSPlans.filter(p => p.SSPlanID !== plan.SSPlanID) || []
    //   });
    // });
   }
  
}
